import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import View from './AccountsOverviewView';
import { currentClientId } from '../../../AdvWorkflow/AdvWorkflowSelector';
import {
  accountsOverviewSelector,
  getAccountEarmarkType,
  getAccountEarmarkTooltip,
  getAccountsTitle,
  isEmptyStateSelector,
} from './AccountsOverviewSelector';
import { accountsSelector } from './AccountsStepSelector';
import {
  SELECT_ACCOUNT,
  EDIT_ACCOUNT,
  DELETE_ACCOUNT,
  DESELECT_ACCOUNT,
} from './AccountsOverviewMenuOptions';
import { selectAccount, deselectAccount, deleteAccount } from './AccountsOverviewActions';
import { setViewId, setDraftAccount } from './AccountsStepActions';
import { EDIT, ADD } from './AccountsStepViews';
import { BASE_ACCOUNT } from '../../AccountsWorkflowConstants';
import {
  getSelectedChildFirstName,
  hasEducationWorkflowData,
} from '../../../ChildrenInfoWorkflow/ChildrenInfoWorkflowSelector';
import largePurchaseItemNameSelector from '../../../LargePurchaseWorkflow/Steps/ItemDescription/ItemDescriptionSelector';
import { hasLargePurchaseWorkflowData } from '../../../LargePurchaseWorkflow/LargePurchaseWorkflowSelector';
import { hasHomePurchaseWorkflowData } from '../../../HomePurchaseWorkflow/HomePurchaseWorkflowSelector';
import { nullablePropertyNameSelector } from '../../../HomePurchaseWorkflow/Steps/PropertyName/PropertyNameSelector';
import { WORKFLOW_ID as DECUMULATION_WORKFLOW_ID } from '../../../DecumulationWorkflow/DecumulationWorkflow.constants';
import { updateValidation } from '../../../AdvWorkflow/AdvWorkflowActions';
import { buildMutation } from '../../../AdvWorkflow/AdvWorkflowHelpers';

const mapStateToProps = (state, ownProps) => {
  let name = '';

  if (hasEducationWorkflowData(state)) {
    name = getSelectedChildFirstName(state, ownProps);
  }

  if (hasLargePurchaseWorkflowData(state)) {
    name = largePurchaseItemNameSelector(state, ownProps);
  }

  if (hasHomePurchaseWorkflowData(state)) {
    name = nullablePropertyNameSelector(state, ownProps);
  }

  return {
    clientId: currentClientId(state, ownProps),
    accountsList: accountsOverviewSelector(state, ownProps),
    graphAccounts: accountsSelector(state, ownProps),
    name,
    accountsTitle: getAccountsTitle(ownProps.workflowId, name),
    isEmptyState: isEmptyStateSelector(state, ownProps),
    isSingleSelection: ownProps.workflowId === DECUMULATION_WORKFLOW_ID,
  };
};

const mapDispatchToProps = dispatch => ({
  onMenuOptionClicked: (workflowId, clientId, id, graphAccounts, name) => menuOption => () => {
    switch (menuOption) {
      case SELECT_ACCOUNT:
        dispatch(selectAccount(graphAccounts, id, workflowId, clientId, name));
        break;
      case EDIT_ACCOUNT:
        dispatch(
          setDraftAccount(
            graphAccounts.find(
              ({ AccountId, frontEndId }) => AccountId === id || frontEndId === id,
            ),
            workflowId,
            clientId,
          ),
        );
        dispatch(setViewId(EDIT, workflowId, clientId));
        break;
      case DELETE_ACCOUNT:
        dispatch(deleteAccount(graphAccounts, id, workflowId, clientId));
        break;
      case DESELECT_ACCOUNT:
        dispatch(deselectAccount(graphAccounts, id, workflowId, clientId, name));
        break;
      default:
    }
  },

  onToggleIsSelected: (
    workflowId,
    clientId,
    id,
    graphAccounts,
    isSelected,
    name,
    isSingleSelection,
  ) => () => {
    if (isSelected) {
      dispatch(deselectAccount(graphAccounts, id, workflowId, clientId, name));
    } else {
      dispatch(selectAccount(graphAccounts, id, workflowId, clientId, name, isSingleSelection));
    }
  },

  onAddAccount: (graphAccounts, workflowId, clientId, name, validationId) => () => {
    dispatch(updateValidation(buildMutation(validationId, []), workflowId, clientId));

    const draftAccount = {
      ...BASE_ACCOUNT,
    };
    draftAccount.AccountEarmark = [
      {
        Type: getAccountEarmarkType(workflowId, name),
        Tooltip: getAccountEarmarkTooltip(workflowId, name),
      },
    ];
    dispatch(setDraftAccount(draftAccount, workflowId, clientId));
    dispatch(setViewId(ADD, workflowId, clientId));
  },
});

const AccountsOverviewContainer = connect(mapStateToProps, mapDispatchToProps)(View);

AccountsOverviewContainer.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number),
  workflowId: PropTypes.string.isRequired,
};

export default AccountsOverviewContainer;
